/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import {
  call,
  put,
  takeEvery,
  takeLatest,
  take,
  cancel,
  delay
} from 'redux-saga/effects'
import {
  FETCH_PROBE_METRICS_DEVICES_CHART,
  POLL_METRIC_DEVICE_CHART_START,
  POLL_METRIC_DEVICE_CHART_STOP,

} from './actionTypes'
import {
  fetchMetricDeviceChartSuccess,
  fetchMetricDeviceChartFailure,

} from './actions'
import { DashboardMetric } from './dashboardMetric';

//------------------------------------ Metric Chart Polling Functions----------------------------
function* fetchMetricDeviceChartPoll(params) {

  try {
    const response = yield call(DashboardMetric.getAllMetricDevicesChart, params)
    yield put(fetchMetricDeviceChartSuccess(response.data))
  } catch (error) {
    yield put(fetchMetricDeviceChartFailure(error))
  }
}

function* pollMetricDeviceChart(action) {
  while (true) {
    yield call(fetchMetricDeviceChartPoll, {
      deviceIds: action.deviceIds,
      metric: action.metric,
      hours: action.hours,
      selectedCIs: action.selectedCIs,
      isInterface: action.isInterface,
      endDate: action.endDate
    })
    yield delay(30000)

  }
}

export function* metricDeviceChartRequestSaga() {
  yield takeEvery(FETCH_PROBE_METRICS_DEVICES_CHART, fetchMetricDeviceChartPoll)
}

export function* metricDeviceChartPollingSaga() {
  while (true) {
    const watcherInstance = yield takeLatest(POLL_METRIC_DEVICE_CHART_START, pollMetricDeviceChart)
    yield take(POLL_METRIC_DEVICE_CHART_STOP)
    yield cancel(watcherInstance)
  }
}